<div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%" (click)="common.outSide($event)">
    <div class="header col-sm-12">
        <div class="col-sm-7">
            <h2> Liste des exutoires limités pour le client </h2>
        </div>
        <div class="col-sm-5 text-right">
            <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
            <!--button class="btn-header uppercase actionPricipal" id="valide" (click)="updateFactAuto()"> Valider </button-->
            <!--div>
          <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
          <label class="text-left uppercase text-underline historique">Voir les documents</label>
        </div-->
        </div>
    </div>

    <div class="col-sm-12 ligneBon liste">
        <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listLimitExu || []"
            [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
            [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
            [selected]="selected">

            <ngx-datatable-column prop="article.code">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader">
                        <span class="uppercase"> Code </span>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value || row?.article?.libelleObjetEntite}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="article.libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader">
                        <span class="uppercase"> Libellé </span>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value || row?.article?.libelleObjetEntite}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="chantier.numChantier">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader">
                        <span class="uppercase"> Chantier </span>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.chantier && row.chantier.id">
                        {{value}} {{row.chantier ? (row.chantier.responsable ? '/ ' +row.chantier.responsable : '') :
                        ''}}
                        {{row.chantier ? (row.chantier.adresse1 ? ' / ' + row.chantier.adresse1 : '') : ''}}
                        {{row.chantier ? (row.chantier.ville ? '/ ' + row.chantier.ville : '') : ''}}
                    </span>
                    <span *ngIf="!row.chantier || (row.chantier && !row.chantier.id)">
                        Tous
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                [resizeable]="false">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <div class="text-center">
                        <button class="btn-detail" (click)="showFormEdit(row);">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <button class="btn-detail" (click)="deleteLigne(row)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
    <div class="addLigne col-sm-12 uppercase">
        <div class="col-sm-7 text-left">
            <button class="btn-add" id="addLigne" (click)="showFormEdit({});">
                <i class="fa fa-plus"></i>
            </button>
            <span (click)="showFormEdit({});">Ajouter une ligne</span>
        </div>
        <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isEdit" #formEdit
    (click)="common.outSide($event)">
    <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
        <h4 class="modal-title pull-left col-sm-8"> Ajouter un article </h4>
        <div class="col-sm-4 text-right">
            <button type="button" class="btn-header uppercase" (click)="selectedRow = {};isEdit = false;"> Fermer
            </button>
            <button type="button" class="btn-header uppercase actionPricipal" (click)="validerFormEdit();">
                Valider </button>
        </div>
    </div>
    <div class="modalFicheClient col-sm-12">
        <div class="col-sm-12">
            <div class="form-group items col-sm-12">
                <label class="col-sm-5 champ" style="padding:0px">
                    Article :
                </label>
                <div class="col-sm-7 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.id}">
                    <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                        (selectfunction)="selectedRow.article = $event" [notOblig]="true" [label]="''"
                        [selectvalue]="true" [results]="dataArticle" [id]="'modedepaie article'"
                        [defaultsearch]="selectedRow.article ? (selectedRow.article.libelle || selectedRow.article.libelleObjetEntite) : ''"
                        [autohide]="true" [dropdownclass]="'dropDownPrixNego'"
                        [defaultselected]="selectedRow.article"></app-autocomplete>
                </div>
            </div>
            <div class="form-group items col-sm-12">
                <label class="col-sm-5 champ" style="padding:0px">
                    Chantier :
                </label>
                <div class="col-sm-7 champ" style="padding-right: 0px"
                    [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
                    <app-autocomplete [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)"
                        [selectvalue]="true" (selectfunction)="selectedRow.chantier = $event;" [results]="listChantier"
                        [defaultselected]="selectedRow.chantier" [showonclick]="true" [label]="''"
                        id="modedepaie autoCht"
                        [defaultsearch]="selectedRow.chantier ? (selectedRow.chantier.numChantier || selectedRow.chantier.responsable || selectedRow.chantier.libelleObjetEntite) : listChantier[0].libelleObjetEntite"
                        [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="col-sm-12" style="padding: 0;">
                <div class="addLigne col-sm-12 uppercase" style="position: relative; background-color: #fff;">
                    <div class="col-sm-7 text-left" style="padding: 0;">
                        <button class="btn-add" (click)="addLigneDetail()">
                            <i class="fa fa-plus"></i>
                        </button>
                        <span (click)="addLigneDetail()" style="padding-left: 10px;">Ajouter une ligne</span>
                    </div>
                    <h5 class="col-sm-5 text-right" style="padding: 0;"> Liste des exutoires disponibles </h5>
                </div>
            </div>
            <div class="col-sm-12 tableArticle" style="padding: 5px; "
                [ngClass]="{'showQteSupp': showQteSupp, 'notshowQteSupp': !showQteSupp}">
                <ngx-datatable *ngIf="renderTable" class="material" [rows]="selectedRow.listeExutoires || []"
                    style="height: 100%;" [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0"
                    [rowHeight]="'auto'" [selectionType]="'single'"
                    [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas d\'exutoire à afficher'}"
                    [loadingIndicator]="loadingIndicator" [dragulaName]="'bag'"
                    [dragulaModel]="selectedRow.listeExutoires" (directiveDrop)="onDrop($event)"
                    (directiveDrag)="onDrag($event)">
                    <ngx-datatable-column [width]="100" [sortable]="false" [canAutoResize]="false" [resizeable]="false">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="value"
                            let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
                            <div class="selecticon" (click)="selectRow(row)" *ngIf="!row.dragstart">
                                <i class="fa fa-ellipsis-v" style="margin-left: -2px"></i>
                            </div>
                            <div class="selecticon" *ngIf="row.dragstart">
                                <i class="fa fa-arrows" aria-hidden="true"></i>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="id" prop="id">
                        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                            let-selectFn="selectFn" let-sort="sortFn">
                            <div class="tableheader">
                                <span class="uppercase"> N° </span>
                            </div>
                        </ng-template>
                        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row"
                            ngx-datatable-cell-template>
                            <div class="getID" id="{{rowIndex}}" class="getID">
                                {{ rowIndex + 1 }}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column prop="exutoire.nom">
                        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                            let-selectFn="selectFn" let-sort="sortFn">
                            <div class="tableheader">
                                <span class="uppercase"> Exutoire </span>
                            </div>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex"
                            ngx-datatable-cell-template>
                            <div style="overflow: hidden;">
                                <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)"
                                    [id]="'modedepaie exutoire'" (selectfunction)="setExutoire($event, rowIndex)"
                                    [results]="listExutoire" [showonclick]="true" [label]="''" [defaultselected]="row"
                                    [defaultsearch]="row ? (row.libelleObjetEntite || row.nom) : ''"
                                    [dropdownclass]="'dropDownPrixNego'" [container]="true"></app-autocomplete>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [width]="50">
                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                            <button class="btn-detail" (click)="deleteLigneDetail(row)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
</div>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>